import { render, staticRenderFns } from "./BoxedRegister.vue?vue&type=template&id=68b93d5a"
import script from "./BoxedRegister.vue?vue&type=script&lang=js"
export * from "./BoxedRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports